import { useForm as useFormHook } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  updatePasswordSchema,
  useUpdatePasswordMutation,
  type UpdatePasswordFormData,
} from "@core/features/profile";
import { usePlatformStore } from "@platform/store";
import { Loader } from "@themes/pollinator/ui/Loader";
import { PasswordForm } from "./PasswordForm";

/**
 * Container component for PasswordForm.
 * Handles mutations and form state management.
 */
export function PasswordFormContainer() {
  const user = usePlatformStore((s) => s.user);

  const passwordMutation = useUpdatePasswordMutation({
    onSuccess: () => {},
    schema: updatePasswordSchema,
    currentEmail: user?.email || "",
  });

  const form = useFormHook<UpdatePasswordFormData>({
    resolver: zodResolver(updatePasswordSchema),
    mode: "all",
    defaultValues: {
      currentPassword: "",
      password: "",
      confirmPassword: "",
    },
  });

  const handleSubmit = form.handleSubmit(async (data) => {
    try {
      await passwordMutation.mutateAsync(data);
      form.reset();
    } catch (error) {
      form.setError("root", {
        type: "manual",
        message:
          error instanceof Error ? error.message : "Failed to update password",
      });
    }
  });

  const handleCancel = () => {
    form.reset();
  };

  if (!user) {
    return <Loader />;
  }

  return (
    <PasswordForm form={form} onSubmit={handleSubmit} onCancel={handleCancel} />
  );
}

export default PasswordFormContainer;
